import { isTypePersonsSection } from '@platform/contentful';
import { Entry } from 'contentful';
import ContentfulPerson from './ContentfulPerson';
import ContentfulTableOfContentsSetting from './ContentfulTableOfContentsSetting';
import cx from 'classix';
import Divider from './util/Divider';
import { getFullWidthBackgroundStyles } from './util/utils';

const ContentfulPersonsSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypePersonsSection(entry)) {
    return null;
  }

  return (
    /* This is very similar to ContentfulCardSection; could likely re-use code */
    <div className={cx('-mx-2 pt-8 pb-12 px-4', getFullWidthBackgroundStyles(entry))}>
      <div className='max-w-[1440px] mx-auto flex flex-col text-center items-center'>
        <h1 className='max-w-3xl w-full font-header font-bold text-4xl sm:text-5xl text-gray-500 my-3'>
          {entry.fields.header}
        </h1>
        <h2 className='max-w-3xl w-full font-header font-medium text-xl sm:text-2xl leading-6 sm:leading-7 text-gray-400'>
          {entry.fields.subHeader}
        </h2>
        <div className='mx-auto'>
          <Divider />
        </div>
        <div className='mt-4 flex flex-col justify-center sm:grid sm:grid-cols-2  gap-8 sm:gap-y-10 sm:justify-around'>
          {entry.fields.persons?.map((person) => (
            <ContentfulPerson key={person?.sys.id} entry={person} />
          ))}
        </div>
        <ContentfulTableOfContentsSetting entry={entry.fields.tocSetting} />
      </div>
    </div>
  );
};

export default ContentfulPersonsSection;
